var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.features.length)?_c('Grid',{staticStyle:{"margin-top":"3rem"},attrs:{"columns":3}},[_c('h3',[_vm._v("Kollektivtransport")]),_c('Features',{staticClass:"location-features",staticStyle:{"grid-column":"span 2"},attrs:{"value":_vm.features,"columns":2}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }